import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchTrustees = createAsyncThunk("fetchTrustees", (params, {dispatch}) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'trustees',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchTrustees.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchTrustees.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''

        })
        builder.addCase(fetchTrustees.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })
    }
})


export default postSlice.reducer
